/* This convertDate function is used to convert 
given date to Data and Time hours, minutes and Am or PM formats */
import { format } from 'date-fns'
import * as XLSX from 'xlsx'
import { ACTIVITY_ID, ALL_SELECT_LABEL, csvcolumns, indexDBNames, isProcessorDisabled, NONE_LABEL } from './Configuration'
import { I_InquiryList, ProcessFlow } from './types/listDataTypes'
import { anewWhoHttp } from './shared/services/api/anew-who-http'
import { FormCheckListMetadata } from './types/listDataTypes'
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Dialog } from '@capacitor/dialog';
import { Capacitor } from '@capacitor/core'
import { Device } from '@capacitor/device'
import { IPickerModel, Me } from '@rhybus/api'
import { generateGUID } from './shared/utils/globalFunctions'
import { DefaultAllOption, userRole } from './types/CommonTypes'
import { ActionBtnShowHide } from './types/custom'
import { ListNames, TRMRoles ,IDB_INQUIRY_LIST_STORE} from './shared/constants/globalConstants'
import { anewRListsHttp } from './shared/services/api/anew-r-lists-http'
import { saveItems, getAllItemsInStore } from './store/indexed-db/indexedDBHelper'
import { ensureDeferredList } from './modules/TRM/services/trmMetadataService'


export function convertDate(
  serverDate: string | number | Date | null | undefined,
  formatter?: string
) {
  if (!serverDate) return ''

  let dt: Date

  // 1️⃣ YYYY-MM-DD (from <input type="date">)
  if (typeof serverDate === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(serverDate)) {
    const [y, m, d] = serverDate.split('-').map(Number)
    dt = new Date(y, m - 1, d)
  }

  // 2️⃣ UTC midnight timestamp (date-only from backend)
  else if (
    typeof serverDate === 'string' &&
    serverDate.endsWith('T00:00:00Z')
  ) {
    const [datePart] = serverDate.split('T')
    const [y, m, d] = datePart.split('-').map(Number)
    dt = new Date(y, m - 1, d)
  }

  // 3️⃣ Everything else (real timestamps)
  else {
    dt = new Date(serverDate)
  }

  return formatter === 'date'
    ? format(dt, 'MM/dd/yyyy hh:mm a')
    : format(dt, 'MM/dd/yyyy')
}

 export const convertDateToYMD = (dateString: string) => {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";

        return date.toISOString().split("T")[0];
    };



export function formatToLocalDate(serverDate: string | number | Date | null | undefined, formatter: string) {
  let createdDate = ''
  if (serverDate !== '' && serverDate !== null && serverDate !== undefined) {
    let dt = new Date(serverDate)

    // Handle cases where time is 00:00:00 in UTC
    if (dt.getUTCHours() === 0 && dt.getUTCMinutes() === 0 && dt.getUTCSeconds() === 0) {
      // Adjust the date to ensure it reflects the local date without timezone shift
      dt = new Date(dt.getUTCFullYear(), dt.getUTCMonth(), dt.getUTCDate())
    }
    
    if (formatter === 'date') {
      createdDate = format(dt, 'MM/dd/yyyy hh:mm a')
    } else {
      createdDate = format(dt, 'MM/dd/yyyy')
    }
  }
  return createdDate
}
const getSafeDate = (value: any) => {
  if (!value) return null;

  if (
    value === '0001-01-01' ||
    value === '0001-01-01T00:00:00' ||
    value === 'Invalid Date'
  ) return null;

  let parsed: Date;
  if (typeof value === 'string') {
    const input = value.trim();
    const dateOnlyMatch = input.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    const utcIsoMatch = input.match(/^(\d{4})-(\d{2})-(\d{2})T.*Z$/);

    if (dateOnlyMatch) {
      const [, year, month, day] = dateOnlyMatch;
      parsed = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
    } else if (utcIsoMatch) {
      const [, year, month, day] = utcIsoMatch;
      parsed = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
    } else {
      parsed = new Date(input);
    }
  } else {
    parsed = new Date(value);
  }

  if (isNaN(parsed.getTime())) return null;
  return parsed;
};
const toExcelDateSerial = (value: any): number | null => {
  const parsed = getSafeDate(value);
  if (!parsed) return null;

  // Convert to Excel serial date using UTC components to avoid timezone shifts.
  const utcMs = Date.UTC(parsed.getUTCFullYear(), parsed.getUTCMonth(), parsed.getUTCDate());
  return Math.floor(utcMs / 86400000) + 25569;
};
export const exportToExcel = async (
  data: any,
  activeTab?: any,
  selectedColumns?: Array<{ fieldName?: string; displayName?: string }>,
  exportType: 'csv' | 'xlsx' = 'csv',
  customFileName?: string,
  statusMetadata?:any
) => {
  if (!data || !data.length) return;
const isWorkOrder = data.every((item: any) => item.IsWorkOrder === true);
const ISArchived = data.every((item: any) => item.IsArchived === true);
const isRenewalsExport = customFileName === 'Renewals';
const isArchivedExport = customFileName === 'Archived' || ISArchived === true;
 const allKeys = Object.keys(csvcolumns);
  const selectedFieldNames = selectedColumns && selectedColumns.length > 0
    ? selectedColumns.map((col) => String(col.fieldName || '').trim()).filter(Boolean)
    : null;
  const selectedColumnLabels = new Map(
    (selectedColumns || [])
      .filter((col) => col.fieldName)
      .map((col) => [String(col.fieldName), col.displayName])
  );
 
  const isAllowedKey = (key: string) => {
    const hiddenExportFields = ['CompletedDate', 'CanceledDate', 'modifiedOn', 'StatusCode']
    if (hiddenExportFields.includes(key)) return false;
    if (isArchivedExport) {
      return !['WorkOrderCreated', 'WorkOrderAge', 'ETCDate'].includes(key);
    }
    if (isWorkOrder) {
      // For WorkOrders, exclude InquiryAge, but allow ETCDate only if activeTab === 0
      if (key === 'InquiryAge') return false;
      return true;
    }
    return key !== 'WorkOrderCreated' && key !== 'WorkOrderAge' && key !== 'ETCDate';
   };
 
  const filteredKeys = selectedFieldNames && selectedFieldNames.length > 0
    ? selectedFieldNames.filter((key) => (isRenewalsExport || allKeys.includes(key)) && isAllowedKey(key))
    : allKeys.filter((key) => isAllowedKey(key));

  // Determine if export contains a mix of inquiries and work orders
  const hasWorkOrders = data.some((item: any) => item.IsWorkOrder === true);
  const hasInquiries = data.some((item: any) => item.IsWorkOrder !== true);
  const isMixed = hasWorkOrders && hasInquiries;

  //  Map headers dynamically (keep same key, only rename for user clarity)
  const headers = filteredKeys.map((key) => {
    if (isRenewalsExport && selectedColumnLabels.get(key)) {
      return selectedColumnLabels.get(key);
    }

    if (isWorkOrder && key === 'ID') {
      return 'Work Order ID';
    } else if ((customFileName === 'Archived' || ISArchived === true) && key === 'ID') {
      return 'ID';
    } else if (isWorkOrder && key === 'ID') {
      return 'Work Order ID';
    }

    if (isArchivedExport && key === 'InquiryAge') {
      return 'Age';
    }

    // For mixed exports where the UI requested InquiryAge but rows include work orders,
    // show a neutral 'Age' header and compute per-row ages below.
    if (isMixed && key === 'InquiryAge' && !filteredKeys.includes('WorkOrderAge')) {
      return 'Age';
    }

    return csvcolumns[key as keyof typeof csvcolumns];
  });

  const dateFields = [
    'ItemModified',
    'ItemCreated',
    'WorkOrderCreated',
    'RegExpirationDate',
    'SubmittedDate',
    'ETCDate',
    'ArchivedDate',
  ];

const rows = data.map((item: any) => {
  if (!isRenewalsExport) {
    const today = new Date();
today.setUTCHours(0, 0, 0, 0); // remove time part
const createdDate = new Date(item?.SubmittedDate || item?.ItemCreated);
createdDate.setUTCHours(0, 0, 0, 0);
 if (isWorkOrder && !isArchivedExport) {
    // --- Work Order Age calculation ---
    if (item?.WorkOrderCreated) {
      const workOrderDate = new Date(item.WorkOrderCreated);
      workOrderDate.setUTCHours(0, 0, 0, 0);
        const nullCheckerCompleted=  item?.StatusCode === statusMetadata?.[17]?.StatusCode &&
                item.CompletedDate === null
                    ? item.ItemModified || item.modifiedOn || 'NA'
                    : item.CompletedDate;
    const nullCheckerCancelledDate =  (
        item?.StatusCode === statusMetadata?.[3]?.StatusCode ||
        item?.StatusCode === statusMetadata?.[7]?.StatusCode
    ) && item.CanceledDate === null
        ? item.ItemModified || item.modifiedOn || 'NA'
        : item.CanceledDate;
     const hasCompleted = !!nullCheckerCompleted;
      const hasCancelled = !!nullCheckerCancelledDate;
      let diffDays = 0;
      if (hasCompleted) {
        const completedDate = new Date(nullCheckerCompleted);
        completedDate.setUTCHours(0, 0, 0, 0);
        diffDays = Math.floor(
          (completedDate.getTime() - workOrderDate.getTime()) /
            (1000 * 60 * 60 * 24)
        );
      } else if (hasCancelled) {
        const cancelledDate = new Date(nullCheckerCancelledDate);
        cancelledDate.setUTCHours(0, 0, 0, 0);
        diffDays = Math.floor(
          (cancelledDate.getTime() - workOrderDate.getTime()) /
            (1000 * 60 * 60 * 24)
        );
      } else {
        diffDays = Math.floor(
          (today.getTime() - workOrderDate.getTime()) /
            (1000 * 60 * 60 * 24)
        );
      }
 
      item.WorkOrderAge = diffDays;
    }
  } else if (!isArchivedExport) {
  // --- Inquiry Age calculation ---
  const endDate =
    (
      item?.StatusCode === statusMetadata?.[3]?.StatusCode ||
      item?.StatusCode === statusMetadata?.[7]?.StatusCode
    ) &&
    item?.ItemCreated !== null &&
    item?.CanceledDate === null
      ? new Date(item.ItemModified || item.modifiedOn || 'NA')
      : item?.CanceledDate
        ? new Date(item.CanceledDate)
        : today;

  const diffDays = Math.floor(
    (endDate.getTime() - createdDate.getTime()) /
      (1000 * 60 * 60 * 24)
  );

  item.InquiryAge = diffDays;
}
}
 //  Parse Vehicle Information JSON safely
    let vehicleInfo: Record<string, any> = {};
    try {
      vehicleInfo = item?.VehicleInformation
        ? JSON.parse(item.VehicleInformation)
        : {};
    } catch (error) {
      console.warn('Invalid VehicleInformation JSON:', error);
    }
    if (isWorkOrder && isArchivedExport) {
      const index = filteredKeys.indexOf('InquiryAge');

      if (index !== -1) {
        filteredKeys[index] = 'WorkOrderAge';
      }
    }
    //  Construct XLSX row — return array of cell values directly
    return filteredKeys.map((key) => {
      let value: any = item[key] !== undefined ? item[key] : vehicleInfo[key.toLowerCase()];

      // // Add zero padding for ID column
      // if (key === 'ID' && value !== undefined && value !== null) {
      //   return String(value).padStart(6, '0');
      // }
      if (key === 'ActionRequiredStatus') {
        if(item['IsRequestForCancelation']) {
          return 'Cancelation requested'
        } else if (item['IsSalesRequired']) {
        return 'Sales action required'
        }
        else if (item['IsInboundActionRequired']) {
          return 'Inbound action required'
        } else {
          return ''
        }

      }
      if(key === 'ItemCreated' || key === 'WorkOrderCreated' || key === 'SubmittedDate'){
        const dateValue = item.IsWorkOrder ? item.WorkOrderCreated || item.ItemModified || item.ItemModifiedOn : item.ItemCreated || item?.SubmittedDate || item.ItemModified || item.ItemModifiedOn
        return dateValue ? toExcelDateSerial(dateValue) ?? '' : '';
      }
      if (key === 'TeamMembers' && Array.isArray(value)) {
        const names = value
          .map((member) => member?.properties?.defaultDisplay)
          .filter(Boolean)
          .join(', ');
          return names || '';
      }
      // Date fields — use integer Excel date serial so time is never stored.
      if (dateFields.includes(key)) {
        const serial = toExcelDateSerial(value);
        return serial ?? '';
      }

      if (isMixed && key === 'InquiryAge' && !filteredKeys.includes('WorkOrderAge')) {
      const val = item.IsWorkOrder
        ? item.WorkOrderAge
        : item.InquiryAge;

      return val != null ? Number(val) : '';
    }

      // Numeric fields — keep as number
      const isNumericField = ['Year', 'InquiryAge', 'WorkOrderAge'].includes(key);
      if (isNumericField) {
        if (value === undefined || value === null || value === '') return '';
        const numericValue = typeof value === 'string'
          ? Number(value.replace(/[^0-9.-]/g, ''))
          : Number(value);
        return Number.isFinite(numericValue) ? numericValue : '';
      }

      // Whole numbers that should stay as text (e.g. phone, zip, GVW)
      const isWholeNumber = typeof value === 'number'
        ? Number.isInteger(value)
        : typeof value === 'string' && /^[0-9,]+$/.test(value);
      if (isWholeNumber) {
        return value !== undefined && value !== null ? String(value).replace(/,/g, '') : '';
      }

      return value !== undefined && value !== null ? String(value) : '';
    });
  });

  //  Build XLSX worksheet directly from data arrays (no CSV parsing roundtrip)
  const wsData = [headers, ...rows];
  const ws = XLSX.utils.aoa_to_sheet(wsData);

  // Apply date format to all date columns so Excel shows mm-dd-yyyy and allows proper sorting/editing
  const dateColIndexes = filteredKeys
    .map((key, i) => (dateFields.includes(key) ? i : -1))
    .filter((i) => i !== -1);
  const idColIndex = filteredKeys.findIndex((key) => key === 'ID');
  const vinColIndex = filteredKeys.findIndex((key) => key === 'VINNumber');

  const range = XLSX.utils.decode_range(ws['!ref'] || '');
  for (let R = 1; R <= range.e.r; ++R) {
    dateColIndexes.forEach((C) => {
      const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
      const cell = ws[cellAddress];
      if (!cell || cell.v === undefined || cell.v === null || cell.v === '') {
        return;
      }


      // numeric date cells and integer day serial to guarantee date-only behavior.
      const numericValue = Number(cell.v);
      if (!Number.isNaN(numericValue)) {
        cell.t = 'n';
        cell.v = Math.floor(numericValue);
        cell.z = 'mm/dd/yyyy';
      }
    });

   const idCellAddress = XLSX.utils.encode_cell({ r: R, c: idColIndex });
    const idCell = ws[idCellAddress];
    if (idCell && idCell.v !== undefined && idCell.v !== null) { 
      idCell.t = 's'; 
      idCell.v = String(idCell.v).padStart(6, '0');
      idCell.z = '@';
    }
     const vinCellAddress = XLSX.utils.encode_cell({ r: R, c: vinColIndex });
    const vinCell = ws[vinCellAddress];
    if (vinCell && vinCell.v !== undefined && vinCell.v !== null) { 
      vinCell.t = 's'; 
      vinCell.v = String(vinCell.v);
      vinCell.z = '@';
    }
  }

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, customFileName ==='Archived'? 'Archived' : isRenewalsExport ? 'Renewals' : isWorkOrder ? 'WorkOrders' : 'Inquiries');
const timestamp = format(new Date(), 'MM-dd-yyyy hh.mm a');
 const fileName = isRenewalsExport
    ? `Renewals_${timestamp}.xlsx`
    : customFileName === "Archived" || ISArchived
    ? `Archived_${timestamp}.xlsx`
    : isWorkOrder
        ? activeTab === 1
            ? `Completed_WorkOrders_${timestamp}.xlsx`
            : activeTab === 2
                ? `Canceled_WorkOrders_${timestamp}.xlsx`
                : `WorkOrders_${timestamp}.xlsx`
        : activeTab === 2
            ? `Canceled_Inquiries_${timestamp}.xlsx`
            : `Inquiries_${timestamp}.xlsx`;
 
  const platform = Capacitor.getPlatform();

  //  Web download
  if (platform === 'web') {
    const xlsxBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([xlsxBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
  //  Native (mobile) file handling
  else {
    try {
      const info = await Device.getInfo();
      const directory = info.platform === 'android'
        ? Directory.External
        : Directory.Documents;

      // Check if file already exists
      try {
        await Filesystem.stat({ path: fileName, directory });
        await Filesystem.deleteFile({ path: fileName, directory });
      } catch (err) {
        console.log('No existing file found, creating new one.',err);
      }

      // Write the new XLSX file as base64
      const xlsxBase64 = XLSX.write(wb, { bookType: 'xlsx', type: 'base64' });
      await Filesystem.writeFile({
        path: fileName,
        data: xlsxBase64,
        directory,
      });

      await Dialog.alert({
        title: 'Export Successful',
        message: info.platform === 'android' ? 'Please go to your My Files app to view the downloaded XLSX file.' : 'Please go to your Files app to view the downloaded XLSX file.',
      });
    } catch (error) {
      await Dialog.alert({
        title: 'Export Failed',
        message: `Error saving XLSX: ${error}`,
      });
    }
  }
}; 
export const generateCheckList = (dataList: any[], checkField: string, keyField: string, filterByState?: string,gw?:string) => {
  return dataList
    ?.filter(item => ((!filterByState && filterByState !== '' ) || item?.State === filterByState) && item[checkField] === true && (!gw || item?.OverWeightLbs >= gw))
    ?.reduce((acc, item) => {
      acc[item[keyField]] = {checked:false};
      return acc;
    }, {});
};
export const convertDataToChecklistData = (data: FormCheckListMetadata[],checkField: string,me: Me,formType:string) => {
  const checklistData: Record<string, { itemID: string, checked: boolean, tooltip: string, modifiedBy: string, modified: Date, formType: string }> = {};
  data.forEach((item:any) => {
    checklistData[item[checkField]] = {
      itemID: generateGUID(),
      checked: false,
      tooltip: item[checkField],
      modifiedBy: me?.firstName && me?.lastName ? me?.firstName + me?.lastName : '',
      modified: new Date(),
      formType: formType,
    };
    return item;
  });
  return checklistData;
}
// Utility function to check if an item falls under selected age filter
export const isWithinAgeFilter = (ageLabel: string, createdDate: string): boolean => {
  const today = new Date();
  const startOfToday = new Date(today.setHours(0, 0, 0, 0));
  const endOfToday = new Date(today.setHours(23, 59, 59, 999));

  const itemDate = new Date(createdDate);

  const daysAgo = (n: number) => {
    const d = new Date();
    d.setDate(d.getDate() - n);
    d.setHours(0, 0, 0, 0);
    return d;
  };

  switch (ageLabel) {
    case "Today":
      return itemDate >= startOfToday && itemDate <= endOfToday;

    case "Yesterday": {
      const start = daysAgo(1);
      const end = new Date(start);
      end.setHours(23, 59, 59, 999);
      return itemDate >= start && itemDate <= end;
    }

    case "3 Days": {
      const start = daysAgo(3);
      return itemDate >= start && itemDate <= endOfToday;
    }

    case "7 Days": {
      const start = daysAgo(7);
      return itemDate >= start && itemDate <= endOfToday;
    }

    case "15 Days": {
      const start = daysAgo(15);
      return itemDate >= start && itemDate <= endOfToday;
    }

    case "30 Days": {
      const start = daysAgo(30);
      return itemDate >= start && itemDate <= endOfToday;
    }

    case "More than 30 Days":
      return itemDate < daysAgo(30);

    default:
      return true; // no filter applied
  }
};
export const isWithinDateRange = (
  date: string | Date,
  start: Date | null,
  end: Date | null
) => {
  if (!start || !end) return true;

  const created = new Date(date).getTime();

  // Local start of day
  const startTime = new Date(start.setHours(0, 0, 0, 0)).getTime();
  // Local end of day
  const endTime = new Date(end.setHours(23, 59, 59, 999)).getTime();

  return created >= startTime && created <= endTime;
};
// Sorts in place, newest first. Each item's date is parsed once up front instead of twice per
// comparison, which matters on 10K+ row lists; comparator results (and so the order) are unchanged.
export const sortByDateDesc = <T extends Record<string, any>>(items: T[], field: string): T[] => {
  const timestamps = new Map<T, number>()
  for (const item of items) {
    timestamps.set(item, new Date(item[field]).getTime())
  }
  return items.sort((a, b) => timestamps.get(b)! - timestamps.get(a)!)
}
export const formatCount = (value?: number | null): string => {
  const count = typeof value === 'number' && Number.isFinite(value) ? value : 0
  return count.toString().padStart(2, '0')
}
export const returnUserName = (file:any): string => {
  for (const [key, value] of file) {
    if (key === 'createdby') {
      return value
    }
  }
  console.error('Check backend for missing Submitter.')
  return ''
}
export const isUrlValid = (url:string) => {
    return /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,;=]|:|@)|\/|\?)*)?$/i.test(url)
}
/* returnDashesIfNull is used to if the given input have no values or null value it will return the -- */
export function returnDashesIfNull (value: any) {
  return value || '--'
}
export function areContentsEqual(content1: any, content2:any) {
  const extracted1 = extractTextAndStylesFromHTML(content1)
  const extracted2 = extractTextAndStylesFromHTML(content2)
  const textEqual = extracted1.text.trim() === extracted2.text.trim()
  const stylesEqual = JSON.stringify(extracted1.styles) === JSON.stringify(extracted2.styles)
  return textEqual && stylesEqual
}

export function extractTextAndStylesFromHTML(html: any) {
  const parser = new DOMParser()
  const doc = parser.parseFromString(html, 'text/html')
  const text = doc.body.textContent || ''
  const styles:any = []
  const elements: any = doc.body.getElementsByTagName('*')
  for (const el of elements) {
    styles.push({
      tagName: el.tagName,
      className: el.className,
      cssText: el.style.cssText
    })
  }
  return { text, styles }
}
export const decodeHTML = function (str: string) {
  const txt = document.createElement('textarea')
  txt.innerHTML = str
  return txt.value
}

export const removeHtmlTagsUsingDOM = function (data: string) {
  const parser = new DOMParser()
  const doc = parser.parseFromString(data, 'text/html')
  return doc.body.textContent || ''
}

export function removehtmltags(data: string): string {
  if (data !== '' && data !== undefined && data !== null) { return data.replace(/<[^>]+>|&nbsp;/g, '') } else { return '' }
}


/* This toCheckNullValues function is used to check wheather
 the given input containes null values or not 
 if null values are present it will return empty  */
export function toCheckNullValues (value : any) {
  return value || ''
}

/* This validateDate function is used to validate the given input if it is valid Date 
It will true and it will return false if it is incorrect*/
export function validateDate(date: any): boolean {
  if ((date !== undefined) && (date !== '')) {
    const datearr = date.split('-')
    if (datearr == null) { return false }
    const month = datearr[1]
    const day = datearr[2]
    const year = datearr[0]
    if (year === undefined || month === undefined || day === undefined || year === 'undefined' || month === 'undefined' || day === 'undefined') { return false }
    if ((month < 1 || month > 12) || (day < 1 || day > 31 || isNaN(day)) || (year.length > 4 || year === '' || year === 'undefined' || year === undefined || parseInt(year) < 1900 || parseInt(year) > 2099)) { return false } else if (month === 2) {
      const isleap = (year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0))
      if (day > 29 || (day === 29 && !isleap) || isNaN(day)) { return false }
    } else if (month === 4 || month === 6 || month === 9 || month === 11) {
      if (day > 30 || isNaN(day)) { return false }
    }
  } else {
    return false
  }
  return true
}
export function InputFormathandler(e:string) {         
          const hasAlphanumeric = /[a-zA-Z0-9]/.test(e);
          if (!hasAlphanumeric) {
            e = ''; // Directly change the DOM value
          }
          return e
        }

export const FindactivityLog = async (
  requirement: I_InquiryList | null | any,
  notificationMetadata: any[],
  activityID: string,
  isSpecificAction: boolean,
  processerDetails?:boolean
) => {
  const specificUserNotifications = [ACTIVITY_ID.InboundActionRequired,ACTIVITY_ID.SalesActionRequired,ACTIVITY_ID?.InquiryUpdated,ACTIVITY_ID?.WorkOrderUpdated,ACTIVITY_ID?.SalesRepondedInquiry,ACTIVITY_ID?.SalesRepondedWorkOrder,ACTIVITY_ID?.InboundResponded,ACTIVITY_ID?.SalesActionRequiredworkOrder,ACTIVITY_ID?.OutboundResponded,ACTIVITY_ID.ProcessorUnassigned,ACTIVITY_ID?.InquiryCancelDenied,ACTIVITY_ID?.WorkOrderCancelDenied,ACTIVITY_ID?.InquiryCancelRequest,ACTIVITY_ID?.WorkOrderCancelRequest,ACTIVITY_ID?.WorkOrderReinitiated,ACTIVITY_ID?.NewWorkOrder]
  // The activity-log metadata is hydrated in the background after first paint. An
  // action fired inside that window used to read [] and persist a row with a blank
  // subject and message, so wait for the hydration to settle before reading it.
  const activityLogMetadata = await ensureDeferredList(ListNames.TRMActvityLogMetadataList, notificationMetadata)
  const activityLogById = activityLogMetadata?.filter(notification => notification?.ActivityID === activityID)
  const activityLog = activityLogById?.length
    ? activityLogById
    : specificUserNotifications?.includes(activityID) || isSpecificAction
      ? activityLogById
      : activityLogMetadata?.filter(notification => notification?.StatusCode === requirement?.StatusCode)
  const activityMsg = await activityLogText(requirement, activityLog[0]?.ActionMessage, activityID,processerDetails)
  const activitySub = activityLog[0]?.ActionSubject
  return {activityMessage: activityMsg ,activitySubject: activitySub}
}
async function activityLogText(requirement: I_InquiryList | null | any, activityLogText: string, activityID?: string,processerDetails?:IPickerModel) {
   if (activityID === ACTIVITY_ID.ProcessStarted || activityID === ACTIVITY_ID.PacketReceived) {
    let processorDisplayName = ''
    let loginUserDisplayName = ''
    if(processerDetails ){
      processorDisplayName = requirement?.assignedProcessor|| ''
    }else if (requirement?.assignedProcessor) {
      const processor = await anewWhoHttp().OtherByUserId(requirement?.assignedProcessor)
      processorDisplayName = processor?.persona || ''
    }
    if(processerDetails){
      loginUserDisplayName = requirement?.AssignedProcessor || ''
    }else if(requirement?.AssignedProcessor){
      const loginDisplayName = await anewWhoHttp().OtherByUserId(requirement?.AssignedProcessor)
       loginUserDisplayName = loginDisplayName?.persona || ''
    }
// If someone else performed action on behalf of processor
    if (
      loginUserDisplayName &&
      processorDisplayName &&
      loginUserDisplayName !== processorDisplayName
    ) {
      return `${loginUserDisplayName} updated packet received Action on behalf of Processor-${processorDisplayName}`
    }
  // If processor himself performed action
 if (processorDisplayName) {
  if(isProcessorDisabled){
      return `Packet Sent to Processor ${processorDisplayName}`
  }else{
      return `${processorDisplayName} received packet`
    }
  }
}
  let subjectWithReplacedValues = activityLogText
  if (subjectWithReplacedValues?.includes('[Processor Name]')) {
    if (requirement?.AssignedProcessor) {
      const processorName = processerDetails ? requirement?.AssignedProcessor : await anewWhoHttp().OtherByUserId(requirement?.AssignedProcessor)
      if (processorName?.persona) {
        subjectWithReplacedValues = subjectWithReplacedValues.replace(
          /\[Processor Name\]/g,
          processorName.persona
        )
      }
    }
  }
    if (subjectWithReplacedValues?.includes('[User name]')) {
    if (requirement?.UserName) {
        subjectWithReplacedValues = subjectWithReplacedValues.replace(
          /\[User name\]/g,
          requirement.UserName
        )
    }
  }
  if (subjectWithReplacedValues?.includes('[User email]')) {
    if (requirement?.UserEmail) {
        subjectWithReplacedValues = subjectWithReplacedValues.replace(
          /\[User email\]/g,
          requirement.UserEmail
        )
    }
  }

  if (subjectWithReplacedValues?.includes('[File Name]')) {
    if (requirement?.fileName) {
      subjectWithReplacedValues = subjectWithReplacedValues.replace(
        /\[File Name\]/g,
        requirement.fileName
      )
    }
  }

  if (subjectWithReplacedValues?.includes('[Team member name]')) {
    if (requirement?.teamMemberName) {
      subjectWithReplacedValues = subjectWithReplacedValues.replace(
        /\[Team member name\]/g,
        requirement.teamMemberName
      )
    }
  }

  if (subjectWithReplacedValues?.includes('[Name and Email]')) {
    if (requirement?.userInfo) {
      subjectWithReplacedValues = subjectWithReplacedValues.replace(
        /\[Name and Email\]/g,
        requirement.userInfo
      )
    }
  }

  if (subjectWithReplacedValues?.includes('[Security Group]')) {
    if (requirement?.securityGroup) {
      subjectWithReplacedValues = subjectWithReplacedValues.replace(
        /\[Security Group\]/g,
        requirement.securityGroup
      )
    }
  }

  if (subjectWithReplacedValues?.includes('[Color]')) {
    if (requirement?.color) {
      subjectWithReplacedValues = subjectWithReplacedValues.replace(
        /\[Color\]/g,
        requirement.color
      )
    }
  }
  if (subjectWithReplacedValues?.includes('[FuelType]')) {
    if (requirement?.FuelType) {
      subjectWithReplacedValues = subjectWithReplacedValues.replace(
        /\[FuelType\]/g,
        requirement.FuelType
      )
    }
  }
  if (subjectWithReplacedValues?.includes('[PlateType]')) {
    if (requirement?.PlateType) {
      subjectWithReplacedValues = subjectWithReplacedValues.replace(
        /\[PlateType\]/g,
        requirement.PlateType
      )
    }
  }

  if (subjectWithReplacedValues?.includes('[Document name]')) {
    if (requirement?.documentName) {
      subjectWithReplacedValues = subjectWithReplacedValues.replace(
        /\[Document name\]/g,
        requirement.documentName
      )
    }
  }

  if (subjectWithReplacedValues?.includes('[Process Type]')) {
    if (requirement?.processType) {
      subjectWithReplacedValues = subjectWithReplacedValues.replace(
        /\[Process Type\]/g,
        requirement.processType
      )
    }
  }

  if (subjectWithReplacedValues?.includes('[Ownership Type]')) {
    if (requirement?.ownershipType) {
      subjectWithReplacedValues = subjectWithReplacedValues.replace(
        /\[Ownership Type\]/g,
        requirement.ownershipType
      )
    }
  }

  if (subjectWithReplacedValues?.includes('[Vehicle Type]')) {
    if (requirement?.vehicleType) {
      subjectWithReplacedValues = subjectWithReplacedValues.replace(
        /\[Vehicle Type\]/g,
        requirement.vehicleType
      )
    }
  }

    if (subjectWithReplacedValues?.includes('[Cost Type]')) {
    if (requirement?.CostType) {
      subjectWithReplacedValues = subjectWithReplacedValues.replace(
        /\[Cost Type\]/g,
        requirement.CostType
      )
    }
  }
  if (subjectWithReplacedValues?.includes('[State]')) {
    if (requirement?.state) {
      subjectWithReplacedValues = subjectWithReplacedValues.replace(
        /\[State\]/g,
        requirement.state
      )
    }
  }

  if (subjectWithReplacedValues?.includes('[Territory]')) {
    if (requirement?.territory) {
      subjectWithReplacedValues = subjectWithReplacedValues.replace(
        /\[Territory\]/g,
        requirement.territory
      )
    }
  }

  if (subjectWithReplacedValues?.includes('[Tooltip]')) {
    if (requirement?.tooltip) {
      subjectWithReplacedValues = subjectWithReplacedValues.replace(
        /\[Tooltip\]/g,
        requirement.tooltip
      )
    }
  }
  return subjectWithReplacedValues
}



export const removeEmptyValues = (value: string | undefined) => {
  return value == '' || value == null || value == 'None' || value == undefined || value == 'Select' ? '--' : value
}
export function isConcurrencyError(e: unknown): e is Error & { name: "ConcurrencyError" } {
  return e instanceof Error && e.name === "ConcurrencyError"
}

export const applyDateRangeFilter = (
  inquiries: any[],
  startDate: Date | null,
  endDate: Date | null,
  fieldName: "ItemCreated" | "WorkOrderCreated" | "SubmittedDate" | "CanceledDate" | "CompletedDate" = "ItemCreated"
) => {
  return inquiries.filter((item: any) => {
    if (!item[fieldName]) return false; // skip items without date
    return isWithinDateRange(item[fieldName], startDate, endDate);
  });
};

export const cleanSpecialCharsOnly = (value: string): string => {
        return /^[^a-zA-Z0-9]+$/.test(value) ? '' : value.trim();
    }; 
export const safeJSONParse = (value: any, fallback = {}) => {
  try {
    return typeof value === 'string' ? JSON.parse(value) : fallback;
  } catch {
    return fallback;
  }
};
export const buildProcessorOptions = (data: any[]) => {
  const map = new Map<string, DefaultAllOption>()
  let hasNullProcessor = false
  data?.forEach((i: any) => {
    const userId = i?.AssignedProcessor?.userID
    if (!userId) {
      hasNullProcessor = true
      return
    }
    const label = i.AssignedProcessor?.properties?.defaultDisplay || userId
    if (!map.has(userId)) {
      map.set(userId, { label, value: userId })
    }
  })
  const uniqueProcessors = Array.from(map.values()).sort((a, b) => (a.label ?? "").localeCompare(b.label ?? ""))
  if (uniqueProcessors.length === 0 && hasNullProcessor) {
    return [{ label: NONE_LABEL, value: NONE_LABEL }]
  }
  if (uniqueProcessors.length > 1 || hasNullProcessor) {
    return [{ label: ALL_SELECT_LABEL, value: ALL_SELECT_LABEL }, ...uniqueProcessors]
  }
  return uniqueProcessors
}
export const actionButtons = (masterData: I_InquiryList[], processFlowMetadata: ProcessFlow[], userRoles: userRole, me: Me) => {
  const extractedData = masterData?.reduce(
    (acc, item) => {
      acc.ownerIds.add(item?.AnewAccOwnerID?.userID);
      acc.territories.add(item?.Territory);
      return acc;
    },
    { ownerIds: new Set<string>(), territories: new Set<string>() }
  ) || { ownerIds: new Set(), territories: new Set() };

  const AnewAccountOwnerIDs = extractedData.ownerIds;
  const territories = extractedData.territories;
  let actionbuttontnShowHide: ActionBtnShowHide = {
    Cancel: { showButton: false, StatusCode: [] },
    UnderReview: { showButton: false, StatusCode: [] },
    ReSubmit: { showButton: false, StatusCode: [] },
    ConvertToWorkOrder: { showButton: false, StatusCode: [] },
    ScanDocument: { showButton: false, StatusCode: [] },
    Approve: { showButton: false, StatusCode: [] },
    CheckList: { showButton: false, StatusCode: [] },
    AssignProcessor: { showButton: false, StatusCode: [] },
    Complete: { showButton: false, StatusCode: [] },
    PacketReceived: { showButton: false, StatusCode: [] },
    ProcessorComplete: { showButton: false, StatusCode: [] },
    Respond: { showButton: false, StatusCode: [] },
    WorkOrderMaterials: { showButton: false, StatusCode: [] },
    Materialsreceived: { showButton: false, StatusCode: [] },
    InboundActionRequired: { showButton: false, StatusCode: [] },
    SalesActionrequired: { showButton: false, StatusCode: [] },
    PendingProblem: { showButton: false, StatusCode: [] },
    FinalReview: { showButton: false, StatusCode: [] },
    IsCancelRequest: { showButton: false, StatusCode: [] },
    ManageETC : { showButton: false, StatusCode: [] },
    IsTMSID : { showButton: false, StatusCode: [] },
  };
  const cancelSet = new Set<number>()
  const approveSet = new Set<number>()
  const convertToWorkOrderSet = new Set<number>()
  const reSubmitSet = new Set<number>()
  const underReviewSet = new Set<number>()
  const checkListSet = new Set<number>()
  const SalesActionRequiredSet = new Set<number>()
  const InboundActionRequiredSet = new Set<number>()
  const ReportProblemSet = new Set<number>()
  const ScanDocumentSet = new Set<number>()
  const AssignProcessorSet = new Set<number>()
  const CompleteSet = new Set<number>()
  const PacketReceivedSet = new Set<number>()
  const ProcessorCompleteSet = new Set<number>()
  const RespondSet = new Set<number>()
  const WorkOrderMaterialsSet = new Set<number>()
  const FinalReviewSet = new Set<number>()
  const MaterialReceivedSet = new Set<number>()
  const CancelRequestSet = new Set<number>()
  const ManageEtcSet = new Set<number>()
  const TMSIDSet = new Set<number>()
  const userAbleAction = processFlowMetadata?.filter((item) => filterActions(item))
  function filterActions(item: ProcessFlow) {
    const roles: string[] = [];
    if (userRoles?.isTRMSales || AnewAccountOwnerIDs?.has(me?.userId)) roles.push(TRMRoles?.sales);
    if (userRoles?.isTRMAdmin) roles.push(TRMRoles?.admin);
    if (userRoles?.isTRMInbound && userRoles?.inboundTerritories?.some((item) => territories.has(item))) roles.push(TRMRoles?.inbound);
    if (userRoles?.isTRMOutbound && userRoles?.outboundTerritories?.some((item) => territories.has(item))) roles.push(TRMRoles?.outbound);
    if (userRoles?.isTRMProcessor) roles.push(TRMRoles?.processor);
    if (userRoles?.isCustomer) roles.push(TRMRoles?.customer);
    return roles.includes(item?.Role);
  }
      userAbleAction?.forEach((item) => {
        if (item?.IsCancel) {
          actionbuttontnShowHide.Cancel.showButton = true
          cancelSet.add(item?.StatusCode)
        }
        if (item?.IsApprove) {
          actionbuttontnShowHide.Approve.showButton = true
          approveSet.add(item?.StatusCode)
        }
        if (item?.IsConvertToWorkOrder) {
          actionbuttontnShowHide.ConvertToWorkOrder.showButton = true
          convertToWorkOrderSet.add(item?.StatusCode)
        }
        if (item?.IsReSubmit) {
          actionbuttontnShowHide.ReSubmit.showButton = true
          reSubmitSet.add(item?.StatusCode)
        }
        if (item?.IsUnderReview) {
          actionbuttontnShowHide.UnderReview.showButton = true
          underReviewSet.add(item?.StatusCode)
        }
        if (item?.IsSalesActionRequired) {
          actionbuttontnShowHide.SalesActionrequired.showButton = true
          SalesActionRequiredSet.add(item?.StatusCode)
        }
        if (item?.IsInboundActionRequired) {
          actionbuttontnShowHide.InboundActionRequired.showButton = true
          InboundActionRequiredSet.add(item?.StatusCode)
        }
        if (item?.IsReportProblem) {
          actionbuttontnShowHide.PendingProblem.showButton = true
          ReportProblemSet.add(item?.StatusCode)
        }
        if (item?.IsScanDocument) {
          actionbuttontnShowHide.ScanDocument.showButton = true
          ScanDocumentSet.add(item?.StatusCode)
        }
        if (item?.IsAssignProcessor) {
          actionbuttontnShowHide.AssignProcessor.showButton = true
          AssignProcessorSet.add(item?.StatusCode)
        }
        if (item?.IsComplete) {
          actionbuttontnShowHide.Complete.showButton = true
          CompleteSet.add(item?.StatusCode)
        }
        if (item?.IsPacketReceived) {
          actionbuttontnShowHide.PacketReceived.showButton = true
          PacketReceivedSet.add(item?.StatusCode)
        }
        if (item?.IsProcessorComplete) {
          actionbuttontnShowHide.ProcessorComplete.showButton = true
          ProcessorCompleteSet.add(item?.StatusCode)
        }
        if (item?.IsRespond) {
          actionbuttontnShowHide.Respond.showButton = true
          RespondSet.add(item?.StatusCode)
        }
        if (item?.IsWorkOrderMaterials) {
          actionbuttontnShowHide.WorkOrderMaterials.showButton = true
          WorkOrderMaterialsSet.add(item?.StatusCode)
        }
        if (item?.IsMaterialReceived) {
          actionbuttontnShowHide.Materialsreceived.showButton = true
          MaterialReceivedSet.add(item?.StatusCode)
        }
        if (item?.IsCheckList) {
          actionbuttontnShowHide.CheckList.showButton = true
          checkListSet.add(item?.StatusCode)
        }
        if (item?.IsFinalReview) {
          actionbuttontnShowHide.FinalReview.showButton = true
          FinalReviewSet.add(item?.StatusCode)
        }
        if (item?.IsCancelRequest) {
          actionbuttontnShowHide.IsCancelRequest.showButton = true
          CancelRequestSet.add(item?.StatusCode)
        }
        if (item?.IsManageETC) {
          actionbuttontnShowHide.ManageETC.showButton = true
          ManageEtcSet.add(item?.StatusCode)
        }
        if(item?.IsTMSID){
          actionbuttontnShowHide.IsTMSID.showButton = true
          TMSIDSet.add(item?.StatusCode)
        }
      })
      if ( (userRoles?.isTRMInbound || userRoles?.isTRMOutbound) && !userRoles?.territories?.some((item) => territories.has(item))) {
        const userAbleAction = processFlowMetadata?.filter((item) => filterActions(item))
          function filterActions(item: ProcessFlow) {
            const roles: string[] = [];
            if (userRoles?.isTRMInbound) roles.push(TRMRoles?.inbound);
            if (userRoles?.isTRMOutbound) roles.push(TRMRoles?.outbound);
            return roles.includes(item?.Role);
          }
        userAbleAction?.forEach((item) => {
            if (item?.IsCheckList) {
            actionbuttontnShowHide.CheckList.showButton = true
            checkListSet.add(item?.StatusCode)
          }
        })
  }
  actionbuttontnShowHide.Cancel.StatusCode = Array.from(cancelSet)
  actionbuttontnShowHide.Approve.StatusCode = Array.from(approveSet)
  actionbuttontnShowHide.ConvertToWorkOrder.StatusCode = Array.from(convertToWorkOrderSet)
  actionbuttontnShowHide.ReSubmit.StatusCode = Array.from(reSubmitSet)
  actionbuttontnShowHide.UnderReview.StatusCode = Array.from(underReviewSet)
  actionbuttontnShowHide.SalesActionrequired.StatusCode = Array.from(SalesActionRequiredSet)
  actionbuttontnShowHide.InboundActionRequired.StatusCode = Array.from(InboundActionRequiredSet)
  actionbuttontnShowHide.PendingProblem.StatusCode = Array.from(ReportProblemSet)
  actionbuttontnShowHide.ScanDocument.StatusCode = Array.from(ScanDocumentSet)
  actionbuttontnShowHide.AssignProcessor.StatusCode = Array.from(AssignProcessorSet)
  actionbuttontnShowHide.PacketReceived.StatusCode = Array.from(PacketReceivedSet)
  actionbuttontnShowHide.Complete.StatusCode = Array.from(CompleteSet)
  actionbuttontnShowHide.ProcessorComplete.StatusCode = Array.from(ProcessorCompleteSet)
  actionbuttontnShowHide.Respond.StatusCode = Array.from(RespondSet)
  actionbuttontnShowHide.WorkOrderMaterials.StatusCode = Array.from(WorkOrderMaterialsSet)
  actionbuttontnShowHide.Materialsreceived.StatusCode = Array.from(MaterialReceivedSet)
  actionbuttontnShowHide.CheckList.StatusCode = Array.from(checkListSet)
  actionbuttontnShowHide.FinalReview.StatusCode = Array.from(FinalReviewSet)
  actionbuttontnShowHide.IsCancelRequest.StatusCode = Array.from(CancelRequestSet)
  actionbuttontnShowHide.ManageETC.StatusCode = Array.from(ManageEtcSet)
  actionbuttontnShowHide.IsTMSID.StatusCode = Array.from(TMSIDSet)
  return actionbuttontnShowHide
}


export const checkunassignedInquiries = async (): Promise<boolean> => {
        try {
          return await new Promise<boolean>((resolve, reject) => {
            const request = indexedDB.open(indexDBNames?.InquiriesList!);
            request.onsuccess = () => {
              const db = request.result;
              // Check if the object store exists
              if (!db.objectStoreNames.contains(IDB_INQUIRY_LIST_STORE)) {
                console.warn("Object store 'inquiries' does not exist");
                db.close();
                resolve(false);
                return;
              }
    
              const transaction = db.transaction(IDB_INQUIRY_LIST_STORE, "readwrite");
    
              const store = transaction.objectStore(IDB_INQUIRY_LIST_STORE);
    
              const clearRequest = store.clear();
              clearRequest.onsuccess = () => {
                console.log("Successfully cleared the inquiries object store");
              };
    
              clearRequest.onerror = (event) => {
                console.error("Error clearing object store:", event);
                db.close();
                reject(new Error("Failed to clear object store"));
              };
    
              transaction.oncomplete = () => {
                db.close();
                resolve(true);
              };
    
              transaction.onerror = (event) => {
                console.error("Transaction error:", event);
                db.close();
                reject(new Error("Transaction failed"));
              };
    
              transaction.onabort = (event) => {
                console.error("Transaction aborted:", event);
                db.close();
                reject(new Error("Transaction aborted"));
              };
            };
    
            request.onerror = (event) => {
              console.error("Error opening database:", event);
              reject(new Error("Failed to open database"));
            };
    
            request.onblocked = (event) => {
              console.warn("Database open request blocked:", event);
              reject(new Error("Database blocked"));
            };
          });
        } catch (err) {
          console.error("Error clearing object store:", err);
          return false;
        }
      };

type FieldElement =
  | HTMLInputElement
  | HTMLTextAreaElement
  | HTMLSelectElement
  | HTMLDivElement
  | HTMLElement
export const focusAndScrollToField = (
  ref: React.RefObject<HTMLElement | null>
) => {
  if (!ref?.current) return;
  let elementToFocus: HTMLElement | null = ref.current;
  // If the element itself is not an input, try to find one inside
  if (
    !(elementToFocus instanceof HTMLInputElement) &&
    !(elementToFocus instanceof HTMLTextAreaElement) &&
    !(elementToFocus instanceof HTMLSelectElement)
  ) {
    const innerInput = elementToFocus.querySelector(
       "input, textarea, select, [contenteditable='true']"
    ) as HTMLElement | null;

    if (innerInput) {
      elementToFocus = innerInput;
    }
  }
  elementToFocus.focus({ preventScroll: true })
  ref.current.scrollIntoView({
    behavior: "smooth",
    block: "center"
  })
}



export const focusFirstInvalidField = (
  errors: Record<string, any>,
  fieldRefs: Record<string, React.RefObject<FieldElement | null>>,
  fieldOrder: string[]
) => {
  for (const field of fieldOrder) {
    const errorValue = errors[field];

    const hasError =
      errorValue === true ||
      (typeof errorValue === "object" &&
        Object.values(errorValue).some(Boolean));

    if (hasError && fieldRefs[field]) {
      requestAnimationFrame(() => {
        focusAndScrollToField(fieldRefs[field]);
      })
      break;
    }
  }
};
 export const toUtcStringOrNull = (value: any): string | null => {
    if (value === null || value === undefined) return null

    const raw = String(value).trim()
    if (!raw) return null

    const ymdMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})$/)
    if (ymdMatch) {
      const date = new Date(Date.UTC(Number(ymdMatch[1]), Number(ymdMatch[2]) - 1, Number(ymdMatch[3])))
      return Number.isNaN(date.getTime()) ? null : date.toUTCString()
    }

    const dmyMatch = raw.match(/^(\d{2})[-/](\d{2})[-/](\d{4})$/)
    if (dmyMatch) {
      const date = new Date(Date.UTC(Number(dmyMatch[3]), Number(dmyMatch[2]) - 1, Number(dmyMatch[1])))
      return Number.isNaN(date.getTime()) ? null : date.toUTCString()
    }

    const parsed = new Date(raw)
    return Number.isNaN(parsed.getTime()) ? null : parsed.toUTCString()
  }
      
  export const buildVersionChecker = async () => {
        const buildVersion = Array.from(await(await anewRListsHttp().getList(ListNames.TRMBuildModifiedList)).query().orderBy([{ orderBy: "ItemModified", ascending: false }]).top(1).get())as any[]; // only the latest row is read
        const currentVersionItem = buildVersion && buildVersion.length > 0 ? buildVersion[0] ?? null : null;
        const currentVersion = buildVersion && buildVersion.length > 0 ? buildVersion[0]?.BuildVersion ?? null : null;
        const storedVersionDb = await getAllItemsInStore(ListNames.TRMBuildModifiedList);
        const storedVersion = storedVersionDb && storedVersionDb.length > 0 ? storedVersionDb[0]?.BuildVersion ?? null : null;
        if(currentVersion !== null && (currentVersion !== null || storedVersion !== null) && currentVersion !== storedVersion){
            if ('databases' in indexedDB) {
              const dbs = await indexedDB.databases();
              for (const db of dbs) {
                indexedDB.deleteDatabase(db.name!);
              }
            } else {
              console.warn('IndexedDB cleanup limited - databases() not supported');
            }
            saveItems(ListNames.TRMBuildModifiedList, [currentVersionItem]).then(() => {
              
            })
        }
      }
